/* global modForm */
import { getNextStepId, getPrevStepId, getConsentListing } from '../../../helpers';

/**
 * Skip steps marked with `data-hide-step` until a visible step is reached.
 * @param {string} oldStepId - Previously active step id
 * @param {string} stepId - Requested step id
 * @returns {string|undefined} Resolved step id, or undefined if there is no next/prev to skip to
 */
export function skipHiddenSteps(oldStepId, stepId) {
	if (!stepId) {
		return stepId;
	}

	const navigatingForward = oldStepId === getPrevStepId(stepId);
	const $steps = modForm.opts.fetchAndFormatConsentListings ? Array.from(modForm.opts.steps) : null;

	while (stepId) {
		const $hiddenStep = modForm.opts.form.querySelector(`#${stepId}[data-hide-step]`);
		if (!$hiddenStep) {
			break;
		}

		$hiddenStep.classList.add('skipped');
		if ($steps && ($steps.length - $steps.indexOf($hiddenStep)) === 2) {
			getConsentListing(modForm.opts.getConsentListingCallback);
		}

		const skipToStepId = navigatingForward ? getNextStepId(stepId) : getPrevStepId(stepId);
		if (!skipToStepId) {
			return undefined;
		}
		stepId = skipToStepId;
	}

	const $target = modForm.opts.form.querySelector('#' + stepId);
	if ($target && $target.classList.contains('skipped')) {
		$target.classList.remove('skipped');
	}

	return stepId;
}
